import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { PlanApercu } from "@/components/PlanApercu";

export default function PlanRegularisationDialog({ open, defaultTerritoire, onClose }) {
  const [f, setF] = useState({ territoire: defaultTerritoire || "", date_inspection: "" });
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  const params = () => Object.fromEntries(Object.entries(f).filter(([, v]) => v.trim()));
  const err = (e) => toast.error(formatApiError(e.response?.data?.detail) || e.message);
  const preparer = async () => {
    setBusy(true);
    try { setPlan((await api.get("/conformite/plan-regularisation", { params: params() })).data); } catch (e) { setPlan(null); err(e); } finally { setBusy(false); }
  };
  const creer = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/conformite/plan-regularisation", params());
      toast.success(`${data.creees} tâche(s) créée(s) et assignée(s) à ${data.assignee.name || data.assignee.email}`);
      setPlan(null); onClose();
    } catch (e) { err(e); } finally { setBusy(false); }
  };
  const close = () => { setPlan(null); onClose(); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-2xl" data-testid="plan-dialog">
        <DialogHeader><DialogTitle>Plan de régularisation</DialogTitle>
          <DialogDescription>Une tâche datée par point manquant, expiré ou à renouveler, assignée au gestionnaire GE du territoire. Suivi dans <Link to="/app/taches" className="underline">Tâches</Link>.</DialogDescription></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div><label className="text-xs text-slate-500">Territoire</label>
            <Input value={f.territoire} onChange={(e) => { setF({ ...f, territoire: e.target.value }); setPlan(null); }} placeholder="ex. Martinique" data-testid="plan-territoire" /></div>
          <div><label className="text-xs text-slate-500">Date d'inspection (facultatif)</label>
            <Input type="date" value={f.date_inspection} onChange={(e) => { setF({ ...f, date_inspection: e.target.value }); setPlan(null); }} data-testid="plan-date" /></div>
        </div>
        {plan && (plan.taches.length ? <PlanApercu plan={plan} /> : <div className="text-sm text-slate-500" data-testid="plan-vide">Rien à planifier : tout est à jour ou déjà planifié.</div>)}
        <DialogFooter><Button variant="outline" onClick={close}>Annuler</Button>
          {!plan ? <Button onClick={preparer} disabled={busy} data-testid="plan-preparer">{busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Préparer le plan</Button>
            : <Button onClick={creer} disabled={busy || !plan.taches.length} data-testid="plan-creer" className="bg-[#C5A059] hover:bg-[#A88846] text-white">
              {busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Créer les {plan.taches.length} tâche(s)</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
